module.exports = __webpack_public_path__ + "static/img/logo2.30ab36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/logo2.png
// module id = 2uDV
// module chunks = 0